import { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';

export const useDatadogSessionIdentification = ({
  slug,
  businessToken,
  guid,
  themeName,
}: {
  slug?: string;
  businessToken?: string;
  guid?: string;
  themeName?: string;
}) => {
  useEffect(() => {
    // Set user information for Datadog RUM
    datadogRum.setUser({
      id: businessToken,
      business_token: businessToken,
      business_guid: guid,
      business_slug: slug,
      theme_name: themeName,
    });
  }, [guid, businessToken, slug, themeName]);
};
